import { useEffect } from 'react';
import type { ScheduleModel } from 'entities/campaign';
import { Button } from 'shared/ui/Button';
import { Tooltip } from 'shared/ui/Tooltip';
import { getDataAutoTestAttributes } from 'shared/lib/data-auto-test';
import { useHidable } from 'shared/lib/hooks';
import { getKeys } from 'shared/lib/object';

interface UpdateScheduleProps {
  isLoading: boolean;
  onClick: () => void;
  schedule: ScheduleModel;
}

export function UpdateSchedule({ isLoading, onClick, schedule }: UpdateScheduleProps) {
  const disable = useHidable();
  const isAtLeastSelected = !!getKeys(schedule)
    .map((day) => schedule[day])
    .find((x) => x.isSelected);

  useEffect(() => {
    disable.hide();
  }, [isAtLeastSelected]);

  return (
    <Tooltip
      content={<div className="w-56 text-xs">Please select at least one day to proceed</div>}
      placement="top-end"
      isDisabled={!disable.isShown}
    >
      <div>
        <Button
          loading={isLoading}
          disabled={disable.isShown}
          onClick={() => {
            if (isAtLeastSelected) {
              onClick();

              return;
            }
            disable.show();
          }}
          className="relative w-full"
          {...getDataAutoTestAttributes(['button-update-schedule'])}
        >
          Update schedule
        </Button>
      </div>
    </Tooltip>
  );
}
